// @ts-ignore
import Axios, { AxiosError, AxiosResponse } from 'axios';
import Collection from '@/stores/abstract/Collection';
import Model from '@/stores/abstract/Model';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';

const CancelToken: any = Axios.CancelToken;
const URL: string = '/nhi-language';
const ICON: string = '/icons';
let cancel: any;

// @ts-ignore
export class NHILanguage extends Model<INHILanguage> implements INHILanguage {
  id!: number;
  OID!: number;
  name!: string;
  enabled!: 0 | 1;
  format_locale!: string;		//en_US
  format_fidelio!: string;		//ea
  format_iso_639_1!: string;		//en

  constructor(attributes: any = {}, parentCollection?: any) {
    super(
      {...{
          id: null,
          OID: -1,
          name: '',
          enabled: 1,             //0 | 1
          format_locale: '',      //en_US
          format_fidelio: '',     //ea
          format_iso_639_1: ''    //en
        }, ...attributes}, // Default values
      parentCollection,
    );
  }

  urlRoot(): string {
    return URL;
  }

  url(): string {
    return `${this.urlRoot()}`;
  }
}

export default class NHILanguageCollection extends Collection<NHILanguage>
{
  routeName = 'nhi-language';
  model(): Constructor<NHILanguage>
  {
    return NHILanguage;
  }
  url(): string
  {
    return URL;
  }
  icons(): string
  {
    return ICON;
  }

  /*
   * Patch
   */
  public items_load(): Promise<iResponse<INHILanguage[]>>
  {
  //Retrieve defined languages from NHI.
    return axiosInstance.get( `${this.url()}`, { headers: { 'X-NoCamelCase': 'true' } } )
      .then(
        ( response: AxiosResponse<iReturnStatus_noCamel> ) =>
        {
        //Was all ok?
          const   data = response.data;

          if ( data.response_code !== 200 )
          {
          //Request failed.
            return { error: data.error?.message || "Unknown error" };
          }

        //Return data.
          return { data: data.data };
        }
      ).catch(
        ( e: AxiosError | Error ) =>
        {
          generateLog( { route: this.routeName, message: e } );

          return { error: e.message };
        }
      );
  }
  public item_update( id: string | number, language: NHILanguage ): Promise<iResponse<INHILanguage[]>>
  {
  //Insert or update language in NHI.
    return axiosInstance.put( `${this.url()}/${id}`, language, { headers: { 'X-NoCamelCase': 'true' } } )
      .then(
        ( response: AxiosResponse<iReturnStatus_noCamel> ) =>
        {
        //Was all ok?
          const   data = response.data;

          if ( data.response_code !== 200 )
          {
          //Request failed.
            return { error: data.error?.message || "Unknown error" };
          }

        //Return data.
          return { data: data.data };
        }
      ).catch(
        ( e: AxiosError | Error ) =>
        {
          generateLog( { route: this.routeName, message: e } );

          return { error: e.message };
        }
      );
  }
  public item_remove( id: string | number, language: NHILanguage ): Promise<iResponse<INHILanguage[]>>
  {
  //Remove language from NHI.
    return axiosInstance.put( `${this.url()}/${id}`, language, { headers: { 'X-NoCamelCase': 'true' } } )
      .then(
        ( response: AxiosResponse<iReturnStatus_noCamel> ) =>
        {
        //Was all ok?
          const   data = response.data;

          if ( data.response_code !== 200 )
          {
          //Request failed.
            return { error: data.error?.message || "Unknown error" };
          }

        //Return data.
          return { data: data.data };
        }
      ).catch(
        ( e: AxiosError | Error ) =>
        {
          generateLog( { route: this.routeName, message: e } );

          return { error: e.message };
        }
      );
  }
}
